import { render, staticRenderFns } from "./EmergencyMaterialTable.vue?vue&type=template&id=f4adb4fc"
import script from "./EmergencyMaterialTable.vue?vue&type=script&lang=js"
export * from "./EmergencyMaterialTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports